// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
body:has(.loading-blocker) {
  overflow: hidden;
}
.api-progress-bar {
  position: fixed;
  top: calc(var(--spacing, 0.25rem) * 0);
  z-index: 99999;
  display: block;
  width: 100%;
  .loading-blocker {
    position: fixed;
    top: calc(var(--spacing, 0.25rem) * 0);
    left: calc(var(--spacing, 0.25rem) * 0);
    height: 100%;
    width: 100%;
    background-color: var(--color-black, #000);
    opacity: 50%;
  }
  .progress-bar-inner {
    top: calc(var(--spacing, 0.25rem) * 0);
    height: calc(var(--spacing, 0.25rem) * 1);
    width: 100%;
    overflow: hidden;
    background-color: var(--color-gray-600, oklch(44.6% 0.03 256.802));
    .progress-indicator {
      position: relative;
      height: 100%;
      width: calc(1 / 5 * 100%);
      max-width: calc(var(--spacing, 0.25rem) * 100);
      border-radius: var(--radius-3xl, 1.5rem);
      animation: progressBar 4s infinite ease-in-out;
    }
  }
}
@keyframes progressBar {
  0% {
    left: -10%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: -10%;
  }
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/ApiProgessBar/ApiProgessBar.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACEA;EACW,gBAAe;AACzB;AAED;EACwB,eAAK;EAAC,sCAAK;EAAC,cAAO;EAAzB,cAAK;EAAZ,WAAM;EAEb;IACyB,eAAK;IAAC,sCAAK;IAAC,uCAAM;IAAzB,YAAM;IAAb,WAAM;IAA2B,0CAAQ;IAAC,YAAU;EAC9D;EAED;IACsB,sCAAK;IAAT,yCAAG;IAAV,WAAM;IAAW,gBAAe;IAAC,kEAAW;IAEnD;MAC8C,kBAAQ;MAA3B,YAAM;MAAtB,yBAAK;MAAC,8CAAS;MAAQ,wCAAW;MACzC,8CAA+C;IAClD;EACJ;AACJ;AAED;EACI;IACI,UAAW;EACd;EACD;IACI,UAAW;EACd;EACD;IACI,UAAW;EACd;AACJ","sourcesContent":[null,"@reference '../../assets/css/main.css';\r\n\r\nbody:has(.loading-blocker) {\r\n    @apply overflow-hidden;\r\n}\r\n\r\n.api-progress-bar {\r\n    @apply w-full block fixed top-0 z-99999;\r\n\r\n    .loading-blocker {\r\n        @apply w-full h-full fixed top-0 left-0 bg-black opacity-50;\r\n    }\r\n\r\n    .progress-bar-inner {\r\n        @apply w-full h-1 top-0 overflow-hidden bg-gray-600;\r\n\r\n        .progress-indicator {\r\n            @apply w-1/5 max-w-100 h-full rounded-3xl relative;\r\n            animation: progressBar 4s infinite ease-in-out;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes progressBar {\r\n    0% {\r\n        left: -10%;\r\n    }\r\n    50% {\r\n        left: 100%;\r\n    }\r\n    100% {\r\n        left: -10%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
